import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { Dropdown, Modal } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'
import useFilterSearchPagination from 'pages/parts/useFilterSearchPagination'

import { formatDate, returnSign, formatMoney, formatMoneyInput, findKeyFromArrayByValue } from 'helpers/helpers'
import { httpOk, GET, POST, PUT } from 'helpers/api'
import { hasPermission } from 'helpers/permissions'

function Index() {
	const { t } = useTranslation()

	// Фильтр по роли
	const roleFilters = [
		{ id: 'ROLE_OWNER', name: 'Владелец' },
		{ id: 'ROLE_PARTNER', name: 'Партнёр' },
		{ id: 'all', name: 'Все' },
	]

	// Фильтр по статусу самого пользователя
	const userStatuses = [
		{ id: 1, name: 'Активные' },
		{ id: -1, name: 'Удалённые' },
		{ id: 'all', name: 'Все' },
	]

	// Фильтр по состоянию торговых точек пользователя
	const posStates = [
		{ id: 'active', name: 'Есть активные точки' },
		{ id: 'deleted', name: 'Все точки удалены' },
		{ id: 'inactive', name: 'Нет активных точек' },
		{ id: 'none', name: 'Нет точек' },
	]

	const [selectedItem, setSelectedItem] = useState({
		'login': '',
		'phone': '',
		'password': '',
	})
	const [data, setData] = useState([])
	const [payments, setPayments] = useState([])
	const [modalUser, setModalUser] = useState(false)
	const [modalPayment, setModalPayment] = useState(false)
	const [modalPaymentHistory, setModalPaymentHistory] = useState(false)
	const [modalStatus, setModalStatus] = useState(false)
	const [statusItem, setStatusItem] = useState({ 'id': 0, 'next_status': -1 })
	const [modalBulkDelete, setModalBulkDelete] = useState(false)
	const [bulkDelete, setBulkDelete] = useState({ total: null, items: [] })
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const {
		filterData,
		setFilterData,
		appliedFilterData,
		setAppliedFilterData,
		filterDataExist,
		setFilterDataExist,
		pagination,
		setPagination,
		applySearch,
		applyFilters,
		paginate,
		resetToInitialFilters,
	} = useFilterSearchPagination({
		initialFilterData: { 'role': 'ROLE_OWNER', 'search': '', 'status': 1, 'pos_state': null, 'page': null },
		initialPagination: {
			url: '/admin/users',
			response: null
		},
	})

	async function searchWithFilter(nextFilterData = filterData) {
		var filterDataCopy = { ...nextFilterData }
		var filterUrl = "/admin/users"
		var urlParams = ""
		checkFilter(filterDataCopy)

		if (filterDataCopy.role && filterDataCopy.role !== 'all')
			urlParams += returnSign(urlParams) + 'role=' + filterDataCopy.role
		if (filterDataCopy.status)
			urlParams += returnSign(urlParams) + 'status=' + filterDataCopy.status
		if (filterDataCopy.pos_state)
			urlParams += returnSign(urlParams) + 'pos_state=' + filterDataCopy.pos_state
		if (filterDataCopy.search)
			urlParams += returnSign(urlParams) + 'search=' + filterDataCopy.search
		if (filterDataCopy.page)
			urlParams += returnSign(urlParams) + 'page=' + filterDataCopy.page

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
			// массовое удаление считаем по тем фильтрам, что реально применены к списку
			setAppliedFilterData(filterDataCopy)
		}

		setDropdownIsOpen(false)
	}

	async function createUpdate(e) {
		e.preventDefault();
		var selectedItemCopy = { ...selectedItem }

		if (!selectedItemCopy.id) return

		var response = await PUT('/admin/users', selectedItemCopy)

		if (httpOk(response)) {
			toggleModal(false)
			searchWithFilter()
		}
	}

	async function partnerPayment(e) {
		e.preventDefault();

		var response = await POST('/admin/partner-payment', selectedItem, { loader: true })
		if (httpOk(response)) {
			setSelectedItem({})
			setModalPayment(false)
			searchWithFilter()
		}
	}

	function toggleModal(bool = false, item = {}) {
		if (bool) {
			item.role = 'ROLE_OWNER'
			setSelectedItem(item)
		} else {
			setSelectedItem({
				'login': '',
				'phone': '',
				'password': '',
				'role': 'ROLE_OWNER',
			})
		}

		setModalUser(bool)
	}

	function toggleModalPayment(bool = false, item = {}) {
		setModalPayment(bool)
		setSelectedItem(item)
	}

	function toggleModalPaymentHistory() {
		setPayments([])
	}

	// Пометить пользователя удалённым (status = -1) или вернуть в работу (status = 1)
	function toggleModalStatus(bool = false, item = {}, status = -1) {
		setStatusItem(bool ? { ...item, 'next_status': status } : { 'id': 0, 'next_status': -1 })
		setModalStatus(bool)
	}

	async function changeStatus() {
		const response = await PUT('/admin/users/status', {
			'id': statusItem.id,
			'status': statusItem.next_status,
		}, { loader: true })

		if (httpOk(response)) {
			toggleModalStatus(false)
			searchWithFilter()
		}
	}

	// Массовое удаление доступно, только когда выбрано состояние точек и оно не «есть активные»:
	// владельцев с работающей точкой пакетом не сносим
	function bulkDeleteAllowed(currentFilterData = appliedFilterData) {
		return ['deleted', 'inactive', 'none'].includes(currentFilterData.pos_state)
	}

	function bulkDeleteParams() {
		const params = { 'pos_state': appliedFilterData.pos_state }
		if (appliedFilterData.search) params.search = appliedFilterData.search
		if (appliedFilterData.role && appliedFilterData.role !== 'all') params.role = appliedFilterData.role

		return params
	}

	async function toggleModalBulkDelete(bool = false) {
		if (!bool) {
			setModalBulkDelete(false)
			return
		}

		setBulkDelete({ total: null, items: [] })
		setModalBulkDelete(true)

		const response = await GET('/admin/users/bulk-delete-preview', bulkDeleteParams(), { loader: true })
		if (httpOk(response)) {
			setBulkDelete({ 'total': response.data.total, 'items': response.data.items ?? [] })
		}
	}

	async function handleBulkDelete(e) {
		e.preventDefault()

		if (!bulkDelete.total) return

		const response = await PUT('/admin/users/bulk-delete', bulkDeleteParams(), { loader: true })
		if (!httpOk(response)) return

		toast.success(`Удалено пользователей: ${response.data.deleted}`)
		toggleModalBulkDelete(false)
		searchWithFilter()
	}

	function resetFilter() {
		resetToInitialFilters((nextFilterData) => {
			searchWithFilter(nextFilterData)
		})
	}

	function checkFilter(currentFilterData) {
		const hasActiveFilters = !!(
			currentFilterData.search ||
			currentFilterData.page ||
			currentFilterData.pos_state ||
			String(currentFilterData.role || 'ROLE_OWNER') !== 'ROLE_OWNER' ||
			String(currentFilterData.status ?? 1) !== '1'
		)

		setFilterDataExist(hasActiveFilters)
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function handlePaginate(page) {
		paginate(page)
		searchWithFilter({ ...filterData, page })
	}

	useEffect(() => {
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					Пользователи [{data.total}]
				</h4>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="d-flex flex-wrap gap-2 mb-3">
						<div>
							<FilterSearch
								filterData={filterData}
								onSearchChange={(search) => applySearch(search, (nextFilterData) => {
									searchWithFilter(nextFilterData)
								})}>
							</FilterSearch>
						</div>
						<div>
							<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
								<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
									Фильтр
								</Dropdown.Toggle>
								<Dropdown.Menu className="dropdown-filter">
									<div className="row">
										<div className="form-group col-md-12">
											<label>Роль</label>
											<Select
												options={roleFilters}
												value={roleFilters.find(option => option.id === (filterData.role ?? 'ROLE_OWNER')) || roleFilters[0]}
												onChange={(option) => setFilterData({
													...filterData,
													'role': option ? option.id : 'ROLE_OWNER',
												})}
												placeholder=""
												noOptionsMessage={() => 'Список пуст'}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
										<div className="form-group col-md-12">
											<label>Статус пользователя</label>
											<Select
												options={userStatuses}
												value={userStatuses.find(option => String(option.id) === String(filterData.status ?? 1)) || userStatuses[0]}
												onChange={(option) => setFilterData({
													...filterData,
													'status': option ? option.id : 1,
												})}
												placeholder=""
												noOptionsMessage={() => 'Список пуст'}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
										<div className="form-group col-md-12">
											<label>Торговые точки</label>
											<Select
												isClearable
												options={posStates}
												value={posStates.find(option => option.id === filterData.pos_state) || null}
												onChange={(option) => setFilterData({
													...filterData,
													'pos_state': option ? option.id : null,
												})}
												placeholder=""
												noOptionsMessage={() => 'Список пуст'}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-md-12">
											<div className="d-flex justify-content-end gap-2">
												<button className="btn btn-secondary"
													onClick={() => setDropdownIsOpen(false)}>
													Отмена
												</button>
												<button className="btn btn-primary"
													onClick={() => applyFilters((nextFilterData) => {
														searchWithFilter(nextFilterData)
													})}>
													Применить
												</button>
											</div>
										</div>
									</div>
								</Dropdown.Menu>
							</Dropdown>
						</div>
						{bulkDeleteAllowed() &&
							<div className="vertical-center">
								<button type="button"
									className="btn btn-outline-danger"
									title="Пометить удалёнными всех пользователей текущей выборки"
									onClick={() => toggleModalBulkDelete(true)}>
									<i className="uil-trash-alt me-1"></i>
									Удалить всех найденных
								</button>
							</div>
						}
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>Фильтр</strong>
								<br />
								{filterData.search &&
									<span className="me-2">
										<b>Поиск: </b>
										<span>{filterData.search}</span>
									</span>
								}
								{String(filterData.role || 'ROLE_OWNER') !== 'ROLE_OWNER' &&
									<span className="me-2">
										<b>Роль: </b>
										<span>{findKeyFromArrayByValue(roleFilters, 'id', filterData.role, 'name')}</span>
									</span>
								}
								{String(filterData.status ?? 1) !== '1' &&
									<span className="me-2">
										<b>Статус: </b>
										<span>{findKeyFromArrayByValue(userStatuses, 'id', filterData.status, 'name')}</span>
									</span>
								}
								{filterData.pos_state &&
									<span className="me-2">
										<b>Точки: </b>
										<span>{findKeyFromArrayByValue(posStates, 'id', appliedFilterData.pos_state, 'name')}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase"
									onClick={resetFilter}>
									Сбросить
								</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '15%' }}>Логин</th>
									<th style={{ 'minWidth': '120px' }} className="text-center">Телефон</th>
									<th style={{ 'minWidth': '120px' }} className="text-center">Дата</th>
									<th style={{ 'width': '10%' }} className="text-center">Роль</th>
									<th style={{ 'width': '10%' }} className="text-center">Статус</th>
									<th style={{ 'width': '10%' }} className="text-end">Точек всего</th>
									<th style={{ 'width': '10%' }} className="text-end">Активные</th>
									<th style={{ 'width': '10%' }} className="text-end">Неактивные</th>
									<th style={{ 'width': '10%' }} className="text-end">Удалённые</th>
									<th style={{ 'minWidth': '33px' }} className="text-end"></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{item.row_number}</td>
										<td className="td-ellipsis">{item.login}</td>
										<td className="text-center">{item.phone}</td>
										<td className="text-center">{formatDate(item.created_at)}</td>
										<td className="text-center">
											{item.role === 'ROLE_OWNER' &&
												<span>Владелец</span>
											}
											{item.role === 'ROLE_PARTNER' &&
												<span>Партнёр</span>
											}
											{item.role === 'ROLE_ADMIN' &&
												<span>Админ</span>
											}
										</td>
										<td className="text-center">
											{item.status === -1 ?
												<span className="text-danger">Удалён</span>
												:
												<span className="text-success">Активен</span>
											}
										</td>
										<td className="text-end">{item.count_pos_total}</td>
										<td className="text-end">{item.count_pos}</td>
										<td className="text-end">{item.count_pos_off}</td>
										<td className="text-end">{item.count_pos_deleted}</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														{hasPermission('admin_users_update') &&
															<div className="table-dropdown-item"
																onClick={() => toggleModal(true, item)}>
																<i className="uil-edit-alt"></i>
																Изменить
															</div>
														}
														{item.role === "ROLE_PARTNER" &&
															<>
																{hasPermission('admin_partners_payment') &&
																	<div className="table-dropdown-item"
																		onClick={() => toggleModalPayment(true, item)}>
																		<i className="uil-edit-alt"></i>
																		Оплата
																	</div>
																}
																<div className="table-dropdown-item"
																	onClick={() => toggleModalPaymentHistory(item)}>
																	<i className="uil-info-circle"></i>
																	История оплат
																</div>
															</>
														}
														{item.role !== "ROLE_ADMIN" && hasPermission('admin_users_update') &&
															<>
																{item.status === -1 ?
																	<div className="table-dropdown-item text-success"
																		onClick={() => toggleModalStatus(true, item, 1)}>
																		<i className="uil-redo"></i>
																		Восстановить
																	</div>
																	:
																	<div className="table-dropdown-item text-danger"
																		onClick={() => toggleModalStatus(true, item, -1)}>
																		<i className="uil-times"></i>
																		Удалить
																	</div>
																}
															</>
														}
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={handlePaginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL STATUS */}
			<Modal show={modalStatus} animation={false} centered
				onHide={() => toggleModalStatus(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{statusItem.next_status === -1 ? 'Удаление пользователя' : 'Восстановление пользователя'}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{statusItem.next_status === -1 ?
						<span>
							Пользователь <b>{statusItem.login}</b> будет помечен удалённым и не сможет войти в систему.
							Торговые точки при этом не меняются. Продолжить?
						</span>
						:
						<span>
							Вернуть пользователя <b>{statusItem.login}</b> в работу?
						</span>
					}
				</Modal.Body>
				<Modal.Footer>
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100"
							onClick={() => toggleModalStatus(false)}>
							Отмена
						</button>
						{statusItem.next_status === -1 ?
							<button className="btn btn-danger w-100" onClick={() => changeStatus()}>
								Удалить
							</button>
							:
							<button className="btn btn-primary w-100" onClick={() => changeStatus()}>
								Восстановить
							</button>
						}
					</div>
				</Modal.Footer>
			</Modal>
			{/* MODAL STATUS */}

			{/* MODAL BULK DELETE */}
			<Modal show={modalBulkDelete} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalBulkDelete(false)}>
				<Modal.Header closeButton>
					<Modal.Title>Массовое удаление пользователей</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => handleBulkDelete(e)} autoComplete="off">
						{bulkDelete.total === null &&
							<div className="text-secondary">Считаем, сколько пользователей попадёт под удаление…</div>
						}

						{bulkDelete.total === 0 &&
							<div className="text-secondary">
								Под текущие фильтры не попало ни одного пользователя
							</div>
						}

						{bulkDelete.total > 0 &&
							<>
								<div className="alert alert-danger mb-3">
									Будет удалено пользователей: <b>{bulkDelete.total}</b>
									<div className="mt-1" style={{ fontSize: '12px' }}>
										Берём активных пользователей, попавших под текущие фильтры списка
										(роль, поиск, состояние точек «{findKeyFromArrayByValue(posStates, 'id', filterData.pos_state, 'name')}»).
										Они будут помечены удалёнными и не смогут войти в систему.
										Торговые точки и администраторы не затрагиваются.
									</div>
								</div>

								<div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
									<table className="table table-bordered mb-0">
										<thead>
											<tr>
												<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
												<th>Логин</th>
												<th>Имя</th>
												<th className="text-end">Точек</th>
											</tr>
										</thead>
										<tbody>
											{bulkDelete.items?.map((item, index) => (
												<tr key={index}>
													<td className="text-center">{index + 1}</td>
													<td className="td-ellipsis">{item.login}</td>
													<td className="td-ellipsis">{item.first_name}</td>
													<td className="text-end">{item.count_pos_total}</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</>
						}

						<div className="d-flex w-100 mt-3 gap-2">
							<button type="button" className="btn btn-warning w-100"
								onClick={() => toggleModalBulkDelete(false)}>
								Отмена
							</button>
							<button type="submit" className="btn btn-danger w-100"
								disabled={!bulkDelete.total}>
								Удалить {bulkDelete.total > 0 ? bulkDelete.total : ''}
							</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL BULK DELETE */}

			{/* MODAL */}
			<Modal show={modalUser} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<span>{t('create')}</span>
							:
							<span>{t('edit')}</span>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => createUpdate(e)} autoComplete="off">
						<div className="form-group">
							<label>Имя</label>
							<input type="text" className="form-control" name="first_name" value={selectedItem.first_name}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'first_name': e.target.value })} />
						</div>
						<div className="form-group">
							<label>Телефон</label>
							<input type="text" className="form-control" name="phone"
								value={selectedItem.phone ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'phone': e.target.value })} />
						</div>
						<div className="form-group">
							<label>Пароль</label>
							<input type="text" className="form-control" name="password" value={selectedItem.password}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'password': e.target.value })} />
						</div>
						<div className="d-flex w-100 gap-2 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal(false)}>{t('cancel')}</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

			{/* MODAL PAYMENT*/}
			<Modal show={modalPayment} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => toggleModalPayment()}>
				<Modal.Header closeButton>
					<Modal.Title>Оплата</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={(e) => partnerPayment(e)} autoComplete="off">
						<div className="form-group">
							<label>Баланс</label>
							<input type="text" className="form-control"
								disabled
								value={formatMoneyInput(selectedItem.partner_balance) ?? ''}
								onChange={() => { }} />
						</div>
						<div className="form-group">
							<label>Сумма</label>
							<input type="text" className="form-control" name="amount"
								value={selectedItem.amount ? formatMoneyInput(selectedItem.amount) : ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9.-]/g, '') })} />
						</div>
						<div className="form-group">
							<label>Примечание</label>
							<input type="text" className="form-control" name="note" value={selectedItem.note}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
						</div>
						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModalPayment()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL PAYMENT*/}

			{/* MODAL PAYMENT HISTORY*/}
			<Modal show={modalPaymentHistory} animation={false} centered
				dialogClassName="update-modal-width"
				onHide={() => setModalPaymentHistory(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						История
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th className="text-nowrap">{t('date')}</th>
									<th className="text-nowrap">{t('note')}</th>
									<th className="text-nowrap text-center">{t('status')}</th>
									<th className="text-nowrap text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{payments?.map((item, index) => (
									<tr key={index}>
										<td>{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
										<td className="td-ellipsis" title={item.note}>{item.note}</td>
										<td className="text-center">
											{item.status === 1 &&
												<span className="text-success">Успешно</span>
											}
											{item.status === -2 &&
												<span className="text-danger">Списание</span>
											}
											{item.status === -3 &&
												<span className="text-danger">Перевод</span>
											}
										</td>
										<td className="text-nowrap text-end">{formatMoney(item.amount)}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL PAYMENT HISTORY*/}
		</>
	)
}

export default Index